import ApiClient from "@/api/ApiClient";
import { MemoruHomeMeResponse } from "@API/src/component/memoruHome/me/types";
import { PutMeRequest } from "@/model/request/me";
import { isTypeMemoruHomeMeResponse } from "@/model/typeGuard/me";

export default class ApiMe {
  public static async fetchMe(): Promise<MemoruHomeMeResponse> {
    const response = await ApiClient.get(`/me`, null);
    if (isTypeMemoruHomeMeResponse(response)) {
      return response;
    }
    throw response;
  }

  public static async putMe(request: PutMeRequest) {
    const response = await ApiClient.put(`/me`, request);
    if (isTypeMemoruHomeMeResponse(response)) {
      return response;
    }
    throw response;
  }
}
